import {ProductBadges} from './productBadges'
import {ProductFavoritesButton} from './productFavoritesButton'
import {ProductDetail} from './productDetail'
import {ProductImageCarousel} from './productImageCarousel'

export {ProductBadges, ProductFavoritesButton, ProductDetail, ProductImageCarousel}
